import { render, staticRenderFns } from "./WizardDatabaseStep.vue?vue&type=template&id=450ee213&"
import script from "./WizardDatabaseStep.vue?vue&type=script&lang=js&"
export * from "./WizardDatabaseStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450ee213')) {
      api.createRecord('450ee213', component.options)
    } else {
      api.reload('450ee213', component.options)
    }
    module.hot.accept("./WizardDatabaseStep.vue?vue&type=template&id=450ee213&", function () {
      api.rerender('450ee213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/WizardDatabaseStep.vue"
export default component.exports